// React Basic and Bootstrap
import React, { Component } from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';

// Import Images
import networkPNG from '../../images/Network_Icon.png';
import mobileNotificationSVG from '../../images/illustrator/Mobile_notification_SVG.svg';
import Colors from "../../Colors";

class WhatIsSTK extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Contactvisible : false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({Contactvisible : true});
    }
    navigateToNewsLetter () {
        const anchor = document.querySelector(`#newsletter`)
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    render() {
        return (
            <React.Fragment>
             <section className="section bg-white border-bottom">
            <div className="container">
                <Row className="justify-content-center">
                    <Col className="text-center">
                        <div className="section-title mb-60">
                            <h4 className="display-3 mb-3" style={{color: Colors.darkBlue()}}>What is Startup Knox?</h4>
                            <p className="text-muted para-desc mb-0 mx-auto">
                                Startups are essential for our region to thrive. We’re two entrepreneurs committed to helping startups launch and grow here. So far, we’ve created a
                                <Link style={{color: Colors.persimmon()}} to="/guide"> Startup Ecosystem Guide</Link>, a
                                <Link style={{color: Colors.persimmon()}} to="/startups"> Startup Directory</Link>, an
                                <Link style={{color: Colors.persimmon()}} to="/investors"> Investor Directory</Link>, a curated
                                <a style={{color: Colors.persimmon()}} href={'https://www.eventbrite.com/c/knoxville-events-for-startups-cwwtwqy--2cchshC1XNzM/'} target="_blank" rel='noopener noreferrer'> Startup Events</a> calendar, and a
                                <a style={{color: Colors.persimmon()}} onClick={this.navigateToNewsLetter}> Newsletter Collective</a>.
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center">
                    <Col lg={5} md={6} style={{display: 'flex', justifyContent: "center"}}>
                        <img src={networkPNG} style={{height: 300}}/>
                    </Col>

                    <Col lg={7} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div className="section-title ml-lg-5">
                            <h4 className="title mb-2" style={{color: Colors.darkBlue()}}>A Clear Vision and Purpose</h4>
                            <p className="text-muted">Startup Knox is the force for collaboration in support of startups. Startups are key to building an economically vibrant and diverse community. Our major goals are to:</p>
                            <ul className="list-unstyled feature-list text-muted">
                                <li><i className="mdi mdi-bullseye mr-2" style={{height: 10, color: Colors.persimmon()}}></i>Grow a significant and sustainable startup economy in Knoxville and the surrounding region.</li>
                                <li><i className="mdi mdi-bullseye mr-2" style={{height: 10, color: Colors.persimmon()}}></i>Establish the Knoxville region as a premier hub for innovation, collaboration, entrepreneurship, and startups.</li>
                                <li><i className="mdi mdi-bullseye mr-2" style={{height: 10, color: Colors.persimmon()}}></i>Energize an active network of BigCos, institutions, investors/funders, entrepreneurs, and startups.</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
            </React.Fragment>
        );
    }
}

export default WhatIsSTK;
